import React from 'react';

const Footer = ({ isSidebar = false, collapsed = false }) => {
  return (
    <div className={`w-full bg-white transition-all duration-300 ${isSidebar
      ? `border-t border-gray-50 ${collapsed ? "pt-4 pb-2 px-0" : "pt-5 pb-2 px-2"}`
      : "text-right px-6 py-2 text-base border-t border-gray-300 shadow-[1px_2px_5px_#b0afaf,-1px_-2px_5px_#ffffff] mt-2 text-[#66615b]"
      }`}>
      <p className={`${isSidebar ? "text-[12px] text-gray-400 font-medium text-center" : ""}`}>
        {isSidebar && collapsed ? "© Neo" : "2024 © Neo Assets Management"}
      </p>
    </div>
  );
};

export default Footer;
